import React from 'react';
import { Section } from './ui/Section';
import { CTAButton } from './ui/CTAButton';
import { ArrowRight, Utensils } from 'lucide-react';
export function MechanismSection() {
  return <Section bg="cream" data-id="element-127">
      <div className="text-center mb-12" data-id="element-128">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#422006]" data-id="element-129">
          El Sistema “Base + 3” 🍗
        </h2>
        <p className="text-xl text-[#78350F] max-w-2xl mx-auto" data-id="element-130">
          Este método está diseñado específicamente para mamás solteras.
        </p>
      </div>

      <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-[#F59E0B]/20 mb-12" data-id="element-131">
        <div className="prose prose-lg max-w-none text-[#78350F] mb-10" data-id="element-132">
          <p data-id="element-133">
            Preparas <strong data-id="element-134">una sola proteína base</strong> con una sazón
            neutra en menos de 20 minutos el domingo. Esa base vive en tu
            nevera.
          </p>
          <p data-id="element-135">
            Cada noche, tomas una porción, le añades{' '}
            <strong data-id="element-136">3 ingredientes</strong> y la transformas en una cena
            totalmente distinta en menos de 10 minutos.
          </p>
        </div>

        <div className="bg-[#FFF8F0] rounded-2xl p-6 border-l-4 border-[#EA580C]" data-id="element-137">
          <h3 className="text-xl font-bold text-[#422006] mb-4 flex items-center gap-2" data-id="element-138">
            <Utensils className="text-[#EA580C]" size={20} data-id="element-139" />
            Por ejemplo: La Magia del Pollo
          </h3>
          <p className="mb-4 text-[#78350F]" data-id="element-140">
            La misma base de pollo desmenuzado se convierte en:
          </p>

          <div className="flex flex-col md:flex-row gap-4 items-center justify-between text-center font-medium" data-id="element-141">
            <div className="bg-white px-4 py-3 rounded-xl shadow-sm w-full md:w-auto text-[#EA580C]" data-id="element-142">
              Lunes: Tacos Dorados 🌮
            </div>
            <ArrowRight className="hidden md:block text-[#F59E0B]" data-id="element-143" />
            <div className="bg-white px-4 py-3 rounded-xl shadow-sm w-full md:w-auto text-[#EA580C]" data-id="element-144">
              Miércoles: Sopa de Pollo 🥣
            </div>
            <ArrowRight className="hidden md:block text-[#F59E0B]" data-id="element-145" />
            <div className="bg-white px-4 py-3 rounded-xl shadow-sm w-full md:w-auto text-[#EA580C]" data-id="element-146">
              Viernes: Wrap César 🌯
            </div>
          </div>
          <p className="mt-6 text-center font-bold text-[#422006] text-lg" data-id="element-147">
            Lo mejor: nadie se da cuenta de que es la misma base.
          </p>
        </div>

        <div className="mt-8 text-[#78350F] text-lg leading-relaxed" data-id="element-148">
          El sistema incluye además snacks SOS para calmar el hambre antes de la
          cena, una guía de planificación dominical de 10 minutos, y postres
          express sin horno para cerrar el día con un toque dulce, sin esfuerzo.
        </div>
      </div>

      <div className="text-center" data-id="element-149">
        <CTAButton data-id="element-150" />
      </div>
    </Section>;
}